<template>
  <div>
    <title-banner :imgType="9" :isProductDetail="false"></title-banner>
    <div class="baoxiu">
      <div class="title">保修期限</div>
      <div v-html="info.warrantyPeriod"></div>

      <div  class="title">保修服务</div>
      <div class="textBox" v-html="info.warrantyRegulations"></div>
<!--      <div style="color: #666666;font-size: 16px;">最近更新时间：2024-11-14</div>-->
    </div>
  </div>
</template>

<script>
import titleBanner from "@/components/titleBanner/index.vue";
import { configList } from "@/utils/http";

export default {
  name: "warranty",
  components: {
    titleBanner
  },
  data() {
    return {
      info: {}
    }
  },
  methods:{
    async getConfigList(){
      const res = await configList();
      this.info = res.rows[0]
    },
  },
  created() {
    this.getConfigList()
  },

  mounted() {

  }
};
</script>

<style lang="scss" scoped>
.baoxiu{
  margin:0 auto;width: 1200px;
  padding: 40px 0;
}
.title{
  font-weight: 400;
  font-size: 32px;
  color: #000000;
  padding: 10px 0;
}
.textBox{
  margin: 10px 0;
  p{
    line-height: 2;
    font-weight: 400;
    font-size: 15px;
    color: #222222;
  }
}
</style>
